import { useState } from 'react';
import DailySchedule from './LeftContainer/DailySchedule';
import News from './NewsContainer/News';
import Staff from './RightContainer/Staff';
import './MainPage.css';

function MainPage() {
	const [selectedPersonSign, setSelectedPersonSign] = useState(null);
	const [courseId, setCourseId] = useState(null);
	const [selectedSchedule, setSelectedSchedule] = useState(null);
	return (
		<div className="main-page">
			<div className="containers left-container">
				<DailySchedule
					selectedPersonSign={selectedPersonSign}
					setCourseId={setCourseId}
					setSelectedPersonSign={setSelectedPersonSign}
					selectedSchedule={selectedSchedule}
					setSelectedSchedule={setSelectedSchedule}
				/>
			</div>
			<div className="containers right-container">
				<Staff
					setSelectedPersonSign={setSelectedPersonSign}
					courseId={courseId}
					setCourseId={setCourseId}
					setSelectedSchedule={setSelectedSchedule}
				/>
			</div>
			<div className="containers bottom-container">
				<News />
			</div>
		</div>
	);
}

export default MainPage;
